import tw from 'twin.macro'

export const DashboardCard = tw.div`relative flex flex-row items-center space-x-5 rounded-lg border p-6 shadow-lg dark:border-gray-700`
